import { motion } from 'framer-motion'
import { useEffect, useState } from 'react'

export default function CookieModal() {
  const [hasAcceptedCookies, setHasAcceptedCookies] = useState(true)
  function getCookiesApprovalStatus() {
    if (window.localStorage.getItem('COOKIE_ACCEPTED') !== 'true') {
      setHasAcceptedCookies(false)
    }
  }

  function handleAcceptCookies() {
    window.localStorage.setItem('COOKIE_ACCEPTED', 'true')
    setHasAcceptedCookies(true)
  }

  useEffect(() => {
    getCookiesApprovalStatus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (hasAcceptedCookies) return null

  return (
    <motion.div
      initial={{ y: '100%' }}
      animate={{ y: '0%', transition: { delay: 1 } }}
      className={'fixed bg-app-purple border bottom-0 left-0 right-0 z-[1001]'}
    >
      <div
        className={
          'max-w-[600px] mx-auto text-sm px-5 py-6 text-white leading-relaxed text-center'
        }
      >
        We use cookies to make Raptures website a better place. Cookies help to
        provide a more personalized experience and relevant advertising for you,
        and web analytics for us.
        <button
          className={
            'text-xs font-medium text-app-purple bg-white block mx-auto mt-5 py-2.5 px-4 rounded font-medium'
          }
          onClick={handleAcceptCookies}
        >
          Accept Cookies
        </button>
      </div>
    </motion.div>
  )
}
